<template>
	<el-dialog
		title="人员详细"
		:visible.sync="dialogVisible"
		width="860px"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		center
		@close="handleClose">
		<!-- 筛选条件 -->
		<div class="filter-bar">
			<label class="label">公司名</label>
			<el-input
				class="filter-input"
				size="small"
				v-model="filterAgentName"
				placeholder="请输入公司名"
				clearable
				@clear="handleFilter"
				@keyup.enter.native="handleFilter">
			</el-input>
			<label class="label">姓名</label>
			<el-input
				class="filter-input"
				size="small"
				v-model="filterUserName"
				placeholder="请输入姓名"
				clearable
				@clear="handleFilter"
				@keyup.enter.native="handleFilter">
			</el-input>
			<label class="label ml10">技能等级</label>
			<el-select size="small" v-model="levelId" clearable placeholder="请选择" @change="handleFilter" style="width: 180px">
				<el-option v-for="item in levelList" :key="item.value" :label="item.levelName" :value="item.id"></el-option>
			</el-select>
			<img class="search-btn" src="@/assets/images/sousuo.png" alt="" @click="handleFilter">
			<el-button icon="el-icon-refresh-right" class="refresh-btn" @click="handleResetFilter"></el-button>
		</div>
		<el-table
			:data="tableData"
			v-loading="tableLoading"
			:row-class-name="tableRowClassName"
			:header-cell-style="{ color: '#444' }"
			border
			style="width: 100%; margin-top: 15px;">
			<el-table-column type="index" label="序号" width="80" align="center" />
			<el-table-column prop="agentName" label="公司名" min-width="200" />
			<el-table-column prop="stuId" label="学员 ID" width="120" align="center" />
			<el-table-column prop="userName" label="姓名" width="120" align="center" />
			<el-table-column prop="levelName" label="技能等级" width="120" align="center" />
		</el-table>

		<!-- 分页 -->
		<el-pagination
			background
			layout="prev, pager, next"
			:current-page.sync="pageNo"
			:page-size.sync="pageSize"
			:total="total"
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange">
		</el-pagination>

		<span slot="footer" class="dialog-footer">
			<el-button size="small" type="primary" @click="dialogVisible = false">确定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import {courseSkillLevelList, courseSkillTotalViewUserList} from "@/api/skill";

export default {
	name: "SkillUserListDialog",
	data() {
		return {
			dialogVisible: false,
			tableLoading: false,
			tableData: [],
			pageNo: 1,
			pageSize: 10,
			total: 0,
			// 查询参数
			queryParams: {
				areaIds: "",
				agentId: "",
				skillId: "",
				showId: "",
			},
			// 筛选条件
			filterUserName: "",
			filterAgentName: "",
			levelId: "",
			levelList: [],
		};
	},
	methods: {
		// 初始化弹窗
		init(params) {
			this.queryParams = {...params};
			this.pageNo = 1;
			this.pageSize = 10;
			this.dialogVisible = true;
			this.fetchData();
			this.getLevelList();
		},
		// 获取数据
		async fetchData() {
			this.tableLoading = true;
			try {
				const res = await courseSkillTotalViewUserList({
					agentId: this.queryParams.agentId,
					skillId: this.queryParams.skillId,
					showId: this.queryParams.showId,
					areaIds: this.queryParams.areaIds,
					pageNo: this.pageNo,
					pageSize: this.pageSize,
					userName: this.filterUserName || undefined,
					agentName: this.filterAgentName || undefined,
					levelId: this.levelId || undefined,
				});

				if (res.code === "0") {
					this.tableData = res.data.list || [];
					this.total = res.data.totalCount || 0;
				} else {
					this.$message.error(res.msg || "获取数据失败");
					this.tableData = [];
					this.total = 0;
				}
			} catch (error) {
				this.$message.error("获取数据失败");
				this.tableData = [];
				this.total = 0;
			} finally {
				this.tableLoading = false;
			}
		},

		// 每页条数变化
		handleSizeChange() {
			this.fetchData();
		},

		// 当前页变化
		handleCurrentChange() {
			this.fetchData();
		},
		// 关闭弹窗
		handleClose() {
			this.tableData = [];
			this.total = 0;
			this.pageNo = 1;
			this.pageSize = 10;
			this.filterUserName = "";
			this.filterAgentName = "";
			this.levelId = "";
		},
		// 筛选
		handleFilter() {
			this.pageNo = 1;
			this.fetchData();
		},
		// 重置筛选
		handleResetFilter() {
			this.filterUserName = "";
			this.filterAgentName = "";
			this.pageNo = 1;
			this.levelId = "";
			this.fetchData();
		},
		// NO.隔行变色
		tableRowClassName({row,rowIndex}) {
			if(rowIndex%2 == 1) {
				return 'blue'
			}else {
				return 'yellow'
			}
		},
		// 获取等级
		getLevelList() {
			courseSkillLevelList({ skillId: this.queryParams.skillId }, true).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				const dataList = res.data || [];
				// 在列表开头插入默认选项
				this.levelList = [{ id: -1, levelName: '无' }, ...dataList];
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.el-table ::v-deep td,
.el-table ::v-deep th {
	padding: 5px 0;
}
::v-deep .el-dialog__body {
	padding: 0 20px 15px;
}
.el-pagination {
	text-align: center;
	margin-top: 20px;
}

/* 筛选栏 */
.filter-bar {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 15px;
	padding: 10px 0;
}

.label {
	font-size: 15px;
	color: #000000;
	white-space: nowrap;
}

.filter-input {
	width: 168px;
	margin-right: 10px;
}

.search-btn {
	width: 32px;
	vertical-align: middle;
	cursor: pointer;
}

.refresh-btn {
	width: 32px;
	height: 32px;
	border: none;
	color: #117FFC;
	padding: 0;
	background-color: rgba(17, 127, 252, 0.2);
	font-weight: bold;
	font-size: 22px;
	vertical-align: bottom;
	margin-left: 5px;
}
</style>
